import { CreditsProvider, useCredits, useMonthlyCredits, useOneTimeCredits } from 'policy-lib';

/**
 * @todo remove these exports once we've remove uses of
 * EnrichmentCreditsProvider
 */

export const EnrichmentCreditsProvider = CreditsProvider;
export const useEnrichmentCredits = useCredits;
export const useMonthlyEnrichmentCredits = useMonthlyCredits;
export const useOneTimeEnrichmentCredits = useOneTimeCredits;